// src/lib/specsUtils.js
// Új JSON séma támogatás + biztonságos visszatérések (sose dobjon .includes hibát)

export const getCompat = (p) => (p && typeof p === "object" ? p.compat || {} : {});
export const getEcosystems = (p) => getCompat(p).ecosystems || {};

export const getRequiresHubs = (p) => {
  const raw = getCompat(p).requiresHubs;
  if (Array.isArray(raw)) return raw;
  return raw ? [raw] : [];
};

export const getCompatibleHubs = (p) => {
  const raw = getCompat(p).compatibleHubs;
  if (Array.isArray(raw)) return raw;
  return raw ? [raw] : [];
};

export const hasDirectControl = (p) => {
  const dc = getCompat(p).directControl || {};
  return !!dc.available;
};

export const getDirectControlMethods = (p) => {
  const dc = getCompat(p).directControl || {};
  const list = Array.isArray(dc.methods) ? dc.methods : [];
  // { app, protocol } normalizálás:
  return list
    .map((m) => ({
      app: (m && m.app) || "",
      protocol: (m && m.protocol) || "",
    }))
    .filter((m) => m.app || m.protocol);
};
